import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Snackbar, Alert, Typography } from "@mui/material";
import { setSnackBar } from "../../store/globalSlice";

const SnackbarProvider = ({ children }) => {
  const dispatch = useDispatch();
  const snackBar = useSelector((st) => st?.global?.snackBar);

  const handleClose = (
    event,
    reason
  ) => {
    if (reason === "clickaway") {
      return;
    }
    dispatch(setSnackBar({ message: "", severity: snackBar?.severity }));
  };



  return (
    <div
      className="App"
      style={{
        transition: "all 50ms linear",
      }}
    >
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        onClose={handleClose}
        message={snackBar?.message}
        open={!!snackBar?.message}
        autoHideDuration={3000}
      >
        <Alert
          onClose={handleClose}
          severity={snackBar?.severity || "success"}
          variant="filled"
          sx={{ width: "100%" }}
        >
          <Typography variant="subtitle2">{snackBar?.message}</Typography>
        </Alert>
      </Snackbar>
      {children}
    </div>
  );
};

export default SnackbarProvider;
